import { Card, Col, Form, Row, Typography } from "antd";
import CustomButton from "components/CustomButton";
import FormInput from "components/FormInput";
import PageHeader from "components/PageHeader";
import { INPUT_TYPE } from "config/constants";
import { IMPORT_REQUEST_TYPE, RECOMMEND_IMPORT, optionImportRequestType } from "features/Purchase/constant";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { formatCurrency, formatCurrencyDollar } from "utils/helperFuncs";
import AddInfo from "./components/AddInfo";
import InfoProvider from "./components/InfoProvider";
import PaymentInfo from "./components/PaymentInfo";
import PopupAddProduct from "./components/PopupAddProduct";
import SelectProduct from "./components/SelectProduct";
import TableProduct from "./components/Table";
import { TitleCard } from "./components/TitleCard";
import "./index.scss";
import useList from "./useList";

function EditImportRequest() {
  const {
    data,
    form,
    handleFinish,
    initialValues,
    handlePasswordKeyPress,
    valueImportWarehouse,
    sellers,
    loadMoreSeller,
    hasMoreSeller,
    handleChangeInfo,
    sellerInfo,
    onSearchSeller,
    handleSubmitCreate,
    formData,
    sumPrice,
    setSumPrice,
    handleKeyPress,
    dataTableProduct,
    setCurrencyFirst,
    currencyFirst,
    handleDeleteProduct,
    handleGetProduct,
    handleAddProduct,
    loadingUpdate,
    handleSubmitSaveAndSendRequest,
    loadingUpdateAndSave,
  } = useList();
  return (
    <div className="create-recommend-import">
      <Form layout="horizontal" form={form} onFinish={handleFinish} initialValues={initialValues}>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <PageHeader
              pageTitle={t("warehouse.edit.editRecommendInport")}
              routes={[
                { path: "#", name: t("warehouse.recommendImport.buy") },
                { path: "/import-request", name: t("warehouse.recommendImport.recommendImport") },
                { path: "/", name: t("warehouse.edit.editRecommendInport") },
              ]}
            />
          </Col>
          <Col span={24} className="form-head">
            <Row gutter={[16, 8]}>
              <Col span={10}>
                <FormInput
                  type={INPUT_TYPE.SELECT}
                  formItemOptions={{
                    label: <Typography.Text strong>{t("warehouse.create.typeRecommend")}</Typography.Text>,
                    name: "type",
                  }}
                  inputOptions={{
                    options: optionImportRequestType,
                    defaultValue: IMPORT_REQUEST_TYPE.DOMESTIC,
                  }}
                />
              </Col>
              <Col span={6}></Col>
              <Col span={8}>
                <FormInput
                  type={INPUT_TYPE.SELECT}
                  formItemOptions={{
                    label: <Typography.Text strong>{t("warehouse.create.warehouseImport")}</Typography.Text>,
                    name: "warehouseID",
                    rules: [{ required: true, message: t("warehouse.create.relueschosseWarrenty") }],
                  }}
                  inputOptions={{
                    placeholder: t("warehouse.create.chosseWarrenty"),
                    options: valueImportWarehouse,
                    onKeyPress: handlePasswordKeyPress,
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 8]}>
              <Col span={10} className="card-container-info">
                <Card title={<TitleCard title={t("warehouse.create.infoProvider")} />} style={{ flexGrow: 1 }}>
                  <InfoProvider
                    sellers={sellers}
                    handleChangeInfo={handleChangeInfo}
                    sellerInfo={sellerInfo}
                    loadMoreSeller={loadMoreSeller}
                    hasMoreSeller={hasMoreSeller}
                    onSearchSeller={onSearchSeller}
                  />
                </Card>
              </Col>
              <Col span={7} className="card-container-info">
                <Card title={<TitleCard title={t("warehouse.create.infoPayment")} />} style={{ flexGrow: 1 }}>
                  <PaymentInfo />
                </Card>
              </Col>
              <Col span={7} className="card-container-info">
                <Card title={<TitleCard title={t("warehouse.create.addInfo")} />}>
                  <AddInfo />
                </Card>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 8]} style={{ marginBottom: "50px" }}>
              <Col span={24}>
                <Card title={<TitleCard title={t("warehouse.create.listProduct")} />}>
                  <Row gutter={[16, 8]}>
                    <Col span={10}>
                      <SelectProduct handleGetProduct={handleGetProduct} />
                    </Col>
                    <Row
                      gutter={10}
                      style={{
                        color: "#2246DC",
                        cursor: "pointer",
                        marginTop: "7px",
                        marginLeft: "10px",
                      }}
                    >
                      <PopupAddProduct form={form} handleAddProduct={handleAddProduct} />
                    </Row>
                  </Row>
                  <Col span={24}>
                    <Form.List name="items">
                      {(items, { remove }) => {
                        return (
                          <div>
                            <TableProduct
                              remove={remove}
                              form={form}
                              dataTableProduct={dataTableProduct}
                              handleDeleteProduct={handleDeleteProduct}
                              setCurrencyFirst={setCurrencyFirst}
                              setSumPrice={setSumPrice}
                              handleKeyPress={handleKeyPress}
                            />
                            {formData?.items?.length > 0 ? (
                              <div style={{ marginTop: "10px" }}>
                                <Typography.Link strong>
                                  {t("warehouse.recommendImport.sumByMoney")}:{" "}
                                  {currencyFirst === "USD"
                                    ? formatCurrencyDollar(sumPrice || 0)
                                    : formatCurrency(sumPrice || 0)}
                                </Typography.Link>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        );
                      }}
                    </Form.List>
                  </Col>
                </Card>
              </Col>
            </Row>
            <Row gutter={[16, 8]}>
              <Col span={24}>
                <Card className="form-footer">
                  <Link to="/import-request">
                    <CustomButton title={t("common.cancel")} />
                  </Link>

                  {data?.status === RECOMMEND_IMPORT.REJECTED || data?.status === RECOMMEND_IMPORT.WAITING_APPROVAL ? (
                    <CustomButton
                      title={t("common.save")}
                      onClick={handleSubmitCreate}
                      loading={loadingUpdate}
                      htmlType={"submit"}
                      type={"primary"}
                    />
                  ) : (
                    <></>
                  )}
                  {data?.status === RECOMMEND_IMPORT.REJECTED ? (
                    <CustomButton
                      type={"primary"}
                      title={t("warehouse.edit.saveandrecommend")}
                      htmlType={"submit"}
                      onClick={handleSubmitSaveAndSendRequest}
                      loading={loadingUpdateAndSave}
                    />
                  ) : (
                    <></>
                  )}
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default EditImportRequest;
